import React, { Component } from 'react'
import { graphql } from 'gatsby'
import he from 'he'
import moment from 'moment-timezone'
import Link from '../utils/link'
import PropertyHeroBanner from '../components/cards/property-hero-banner'
import Property from '../components/cards/property'
import Seo from '../components/seo'
import Map from '../components/map'
import SignOff from '../components/sign-off'
import BedBathCar from '../components/bed-bath-car'
import AreaParkingZone from '../components/area-parking-zone'
import Gallery from '../components/gallery'
import EnquiryForm from '../components/enquiry-form'
import { Close, FloorPlan, RightArrow, Download } from '../components/icons'
import FsLightbox from 'fslightbox-react'
import SearchOverlay from '../components/search-overlay'
import PropertyAgents from '../components/property-agents'

function filterIt(arr, searchKey) {
  return arr.filter(function(obj) {
    return Object.keys(obj).some(function(key) {
      return obj[key].includes(searchKey)
    })
  })
}

// Component to fix beforeChange bug rerendering slick
class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{ this.props.children }</>)
  }
}

class PropertyTemplate extends Component {

  state = {
    showForm: false,
    imageLightbox: false,
    videoLightbox: false,
    floorplanLightbox: false,
    showMore: false
  }

  _toggleForm = (key) => {
    this.setState({ showForm: key })
  }

  openVideo = () => {
    this.setState({ videoLightbox: !this.state.videoLightbox })
  }

  openGallery = () => {
    this.setState({ imageLightbox: !this.state.imageLightbox })
  }

  renderText = (el, i) => {
    if (el.length === 0) return
    if (el.indexOf('•') !== -1) return <li key={i}>{ el.replace(/•/gi, '') }</li>
    return <p key={i} dangerouslySetInnerHTML={{ __html: el }} />
  }

  render() {

    let list = []

    let canSearch = false

    let { showForm, imageLightbox, videoLightbox, floorplanLightbox, showMore } = this.state

    let address = [];

    let { wp, relatedProperties, relatedRentals, teamMembers } = this.props.data

    let property = this.props.data.wpProperty

    let { externalLinks, agents, images, inspections } = property

    if( property.propertyMeta.displayAddress ) {
      address = property.propertyMeta.displayAddress.split(",")
    }

    let video = ''
    let videos = externalLinks?.length > 0 && filterIt(externalLinks, 'Video')
    if (videos && videos.length) {
      video = `https://www.youtube.com/watch?v=${videos[0].url.split('.be/')[1]}`
    }

    let tour = ''
    let tours = externalLinks?.length > 0 && filterIt(externalLinks, 'Virtual Tour')
    if (tours && tours.length) {
      tour = tours[0].url
    }

    let floorplan = ''
    let floorplans = images?.length > 0 && filterIt(images, 'Floorplan')
    if (floorplans.length) {
      floorplan = floorplans[0].url
    }

    let today = new Date()
    today.setDate(today.getDate() - 1)

    let hasInspections = false
    if (inspections?.length > 0 ) {
      inspections.map((el, i) => {
        if (moment(el.start, "YYYY-MM-DD").tz("Australia/Melbourne").isAfter(today)) hasInspections = true
      })
    }

    let hasAuction = false
    if (property.propertyMeta.auctionDetails?.dateTime ) {
      if (moment(property.propertyMeta.auctionDetails?.dateTime, "YYYY-MM-DD").tz("Australia/Melbourne").isAfter(today)) hasAuction = true
    }

    let postType = property.propertyMeta.commercialListingType === 'sale' ? 'property' : 'rental'

    let propertyType = ( property.propertyMeta.class ).toLowerCase() === 'commercial' ? 'commercial' : 'residential'

    let status = property.propertyMeta.status

    let label = (status === 'listing' || status === 'conditional') ? postType === 'rental' ? 'For Lease' : 'For Sale' : 'Sold'

    let sold = ( property.propertyMeta.commercialListingType === 'sale' && (status !== "listing" && status !== "conditional") )

    let color = propertyType === 'residential' ? '#000000' : '#E7E5E1'

    let signOff = false;

    let addressPartOne = property.propertyMeta.address.unitNumber ? property.propertyMeta.address.unitNumber+'/'+property.propertyMeta.address.streetNumber : property.propertyMeta.address.streetNumber
    let addressLowerCase = (addressPartOne+' '+property.propertyMeta.address.street+', '+property.propertyMeta.address.suburb.name).toLowerCase()
    let addressUrl = encodeURIComponent(addressLowerCase)

    if ( property.propertyMeta.status === 'management' ) {
      postType = 'rental'
      label = 'For Lease'
    }
    if (property.propertyMeta.isLeased) label = 'Leased'

    if( status !== 'listing' ) {
      signOff = <SignOff {...wp.siteSettings.acf.propertiesSoldCta} />
    } else {

      if( propertyType === 'commercial') {
        signOff = <SignOff {...wp.siteSettings.acf.propertiesCommercialCta} />
      } else {

        if( postType === 'rental' ) {
          signOff = <SignOff {...wp.siteSettings.acf.propertiesLeaseCta} />
        } else {
          signOff = <SignOff {...wp.siteSettings.acf.propertiesBuyCta} />
        }
      }
    }

    let soldPrice = '';

    

    if (sold) {
      soldPrice = property.propertyMeta.saleHistory?.length > 0 ? property.propertyMeta.saleHistory[0].salePrice : property.propertyMeta.saleDetails?.salePrice 
      soldPrice = soldPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      
    }

    return (
      <>
        <Seo title={he.decode(property.seo.title)} bodyClass={`${property.slug} ${ ( property.propertyMeta.class ).toLowerCase() === 'commercial' ? 'dark-theme' : '' }      `} description={property.seo.metaDesc} />
        <SearchOverlay canSearch={canSearch} type="buy" postType={postType} propertyType={propertyType} />
        <article className='single-property'>
          <div className='single-property__inner'>
            <div className='single-property__content'>

              { property &&
                <div className='single-property__hero-banner'>
                  <PropertyHeroBanner single={true} label={label} postType={postType} propertyType={ propertyType } {...property} />
                </div>
              }

            </div>

          </div>

          { images.length > 0 &&
            <div className='single-property__gallery'>
              <Gallery images={ images } video={video} openVideo={this.openVideo} openGallery={() => {}} />
            </div>
          }

          <div className='single-property__inner'>

            <div className='single-property__details'>

              <div className={`single-property__enquiry ${showForm ? 'showing' : ''} `}>

                <p className="form-close" onClick={() => this._toggleForm(0)} ><Close color={color} /><span>Close</span></p>

                <EnquiryForm property={property.title} agent={teamMembers?.edges.length > 0 && teamMembers.edges[0].node.info.email} />

              </div>

              <div className='single-property__menu'>

                <div className='single-property__menu-upper'>

                  { address.length >= 2 &&
                    <div className='property__address'>
                      <ul className='address'>
                        <li>{ address[0] }</li>
                        <li>{ address[1] }</li>
                        { address[2] && <li>{ address[2] }</li> }
                      </ul>
                    </div>
                  }

                  { propertyType === 'residential' &&
                    <BedBathCar color={color} carports={ property.propertyMeta.carports } garages={ property.propertyMeta.garages } openSpaces={ property.propertyMeta.openSpaces } beds={ property.propertyMeta.bed } baths={ property.propertyMeta.bath } />
                  }

                  { propertyType === 'commercial' &&
                    <AreaParkingZone color={color} type={property.propertyMeta.zoning} carports={ property.propertyMeta.carports } garages={ property.propertyMeta.garages } openSpaces={ property.propertyMeta.openSpaces } landAreaValue={ property.propertyMeta.landAreaValue } landAreaUnits={ property.propertyMeta.landAreaUnits } floorAreaValue={ property.propertyMeta.floorAreaValue } floorAreaUnits={ property.propertyMeta.floorAreaUnits } />
                  }

                  { property.propertyMeta.displayPrice && !sold &&
                    <p className='price'>{ property.propertyMeta.displayPrice }</p>
                  }
                  { sold && soldPrice && property.propertyMeta.id === '29539342' &&
                      <p className='price'>Contact Agent</p>
                    }
                  { sold && soldPrice && property.propertyMeta.id !== '29539342' &&
                    <p className='price'>${ property.propertyMeta.id === '26308866' ? '850,000' : soldPrice }</p>
                  }
                  { sold && !soldPrice &&
                    <p className='price'>Enquire Now</p>
                  }

                  { postType === 'rental' && propertyType !== 'commercial' && property.propertyMeta.searchPrice &&
                    <p className='price'>${ property.propertyMeta.searchPrice } p/w</p>
                  }

                </div>

                <div className='single-property__menu-lower'>

                  { property.propertyMeta.auctionDetails?.dateTime && hasAuction &&

                    <div className='single-property__inspections'>

                      <h3>Auction</h3>
                      <p className='date'>{ moment(property.propertyMeta.auctionDetails.dateTime).tz("Australia/Melbourne").format('dddd, MMMM Do YYYY h:mm A') }</p>

                    </div>

                  }

                  { inspections.length > 0 && hasInspections && property.title !== '12 Bowlers Avenue, Geelong West VIC' &&

                    <div className='single-property__inspections'>

                      <h3>Inspections</h3>

                      { inspections.map((el, i) => {
                        if (moment(el.start, "YYYY-MM-DD").tz("Australia/Melbourne").isAfter(today)) return ( <p className='date'>{ moment( el.start ).tz("Australia/Melbourne").format('dddd, MMMM Do YYYY h:mm A') }</p>)
                      })}

                    </div>

                  }

                </div>

              </div>

              <div className='single-property__copy'>

                {  property.propertyMeta.heading && <h3 dangerouslySetInnerHTML={{ __html: property.propertyMeta.heading }} /> }

                <div className={`single-property__text ${showMore && 'active'}`}>
                  { property.propertyMeta?.description?.split('\n').map(this.renderText) }
                </div>

                <button
                  type='button'
                  className='btn'
                  onClick={() => this.setState({ showMore: !this.state.showMore })}
                >
                  {showMore ? 'Show Less' : 'Show More'}
                </button>

              </div>

              <div className='single-property__agents'>

                <ul className='agents-menu'>
                  { property.propertyMeta?.soiUrl && <li><a href={property.propertyMeta.soiUrl} target="_blank" rel="noopener noreferrer">Statement <Download color={color} /></a></li> }
                  <li><button onClick={() => this._toggleForm(1)}>Enquire <RightArrow color={color} /></button></li>
                  <li><button type='button' onClick={() => this.setState({ imageLightbox: !imageLightbox })}>Gallery</button></li>
                  { floorplan && <li><button type='button' onClick={() => this.setState({ floorplanLightbox: !floorplanLightbox })}>Floorplan <FloorPlan color={color} /></button></li> }
                  <li><Link to='/appraisals/'>Get an Appraisal</Link></li>
                  { postType === 'rental' && propertyType !== 'commercial' && <li><a target="_blank" href={`https://2apply.com.au/Form?AgentAccountName=gartland&address=${addressUrl}`}>Apply Now</a></li> }
                  { postType === 'rental' && propertyType !== 'commercial' && <li><a target="_blank" href={`https://book.inspectrealestate.com.au/RegisterNew?AgentAccountName=gartland&address=${addressUrl}&Type=rental`}>Book Inspection</a></li> }
                  { tour !== '' && <li><a target="_blank" href={tour}>Virtual Tour</a></li> }
                </ul>

                { teamMembers.edges.length > 0 &&

                  <div className='single-property__agents-accounts'>

                    <PropertyAgents teamMembers={teamMembers} agents={agents} />

                  </div>

                }

              </div>

            </div>

            { teamMembers.edges.length > 0 &&

              <div className='single-property__mobile-agents-accounts'>

                <PropertyAgents teamMembers={teamMembers} agents={agents} />

              </div>
            }

            <div className='single-property__location'>
              <BlockUpdate>
                <Map lat={property.propertyMeta.latitude} lng={property.propertyMeta.longitude} />
              </BlockUpdate>
            </div>
            { property.propertyMeta.status !== 'management' &&
              <>
                { relatedProperties.edges.length > 0 &&
                  <div className='single-property__related'>
                    <div className='single-property__inner'>
                      <div className='single-property__related-menu'>
                        <ul>
                          <li className='heading'>Related Properties</li>
                          <li><Link to=''>View</Link></li>
                        </ul>
                      </div>
                      <div className='single-property__related-properties'>
                        { relatedProperties.edges.map((el, i) => {
                          return ( <Property position='' postType={postType} propertyType={ propertyType } {...el.node} /> )
                        })}
                      </div>
                    </div>
                  </div>
                }
              </>
            }
            { property.propertyMeta.status === 'management' &&
              <>
                { relatedRentals.edges.length > 0 &&
                  <div className='single-property__related'>
                    <div className='single-property__inner'>
                      <div className='single-property__related-menu'>
                        <ul>
                          <li className='heading'>Related Properties</li>
                          <li><Link to=''>View</Link></li>
                        </ul>
                      </div>
                      <div className='single-property__related-properties'>
                        { relatedRentals.edges.map((el, i) => {
                          return ( <Property position='' postType={postType} propertyType={ propertyType } {...el.node} /> )
                        })}
                      </div>
                    </div>
                  </div>
                }
              </>
            }

            { signOff && signOff }

          </div>
        </article>


        { images?.length > 0 &&
          <FsLightbox
            toggler={imageLightbox}
            sources={images.filter((el, idx) => {
              if (el.type === 'Floorplan') return false
              return true
            }).map((el, idx) => {
              return (
                <img
                  key={idx}
                  src={el.url}
                  alt='Gartland'
                />
              )
            })}
          />
        }

        { video &&
          <FsLightbox
            toggler={videoLightbox}
            sources={ [
              video
            ]}
          />
        }

        { floorplan &&
          <FsLightbox
            toggler={floorplanLightbox}
            sources={ [
              <img
                className='floorplan-image'
                src={floorplan}
                alt='Gartland'
              />
            ]}
          />
        }

      </>
    )
  }
}

export const propertyQuery = graphql`
  query ($id: String!, $class: String!, $status: String!, $type: String!, $agentIds: [Int!]!) {
    wpProperty(id: {eq: $id}) {
      title
      slug
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          localFile {
            childImageSharp {
              original {
                src
                width
                height
              }
            }
          }
        }
      }
      propertyMeta {
        id
        heading
        commercialListingType
        auctionDetails {
          dateTime
        }
        address {
          unitNumber
          streetNumber
          street
          suburb {
            name
            postcode
          }
        }
        saleDetails {
          salePrice
        }
        saleHistory {
          salePrice
        }
        addressVisibility
        available
        carports
        garages
        openSpaces
        bed
        bath
        landAreaValue
        landAreaUnits
        floorAreaValue
        floorAreaUnits
        displayPrice
        displayAddress
        searchPrice
        latitude
        longitude
        description
        class
        type
        zoning
        status
        soiUrl
        isLeased
      }
      images {
        url
        thumb_1024
        thumb_180
        type
      }
      externalLinks {
        url
        type
      }
      agents {
        thumbnail
        image
        firstName
        lastName
        email
        staffTypeId
      }
      inspections {
        id
        isRental
        start
        end
      }
    }
    teamMembers: allWpTeam( filter: { info: { id: {in: $agentIds } } } ) {
      edges {
        node {
          id
          title
          slug
          phoneNumbers {
            comment
            number
            typeCode
            type
          }
          info {
            id
            email
            thumbnail
            image
            firstName
            lastName
            staffTypeId
          }
          acf {
            profileImage {
              localFile {
                childImageSharp {
                  original {
                    src 
                  }
                }
              }
            }
          }
        }
      }
    }
    relatedProperties: allWpProperty(
      filter: { id: {ne: $id }, propertyMeta: { class: {eq: $class}, status: {eq: $status}, commercialListingType: {eq: $type}}},
      sort: { date: DESC },
      limit: 4
    ) {
      edges {
        node {
          id
          slug
          title
          date
          propertyMeta {
            id
            address {
              suburb {
                postcode
              }
            }
            saleHistory {
              salePrice
            }
            saleDetails {
              salePrice
            }
            addressVisibility
            heading
            commercialListingType
            available
            carports
            garages
            openSpaces
            bed
            bath
            landAreaValue
            landAreaUnits
            displayPrice
            displayAddress
            searchPrice
            latitude
            longitude
            description
            class
            zoning
            type
            status
          }
          images {
            url
            thumb_1024
            thumb_180
          }
        }
      }
    }
    relatedRentals: allWpProperty(
      filter: { id: {ne: $id }, propertyMeta: {status: {eq: "management"}}}
      sort: { date: DESC }
      limit: 4
    ) {
      edges {
        node {
          id
          slug
          title
          date
          propertyMeta {
            id
            address {
              suburb {
                postcode
              }
            }
            addressVisibility
            heading
            commercialListingType
            available
            carports
            garages
            openSpaces
            bed
            bath
            landAreaValue
            landAreaUnits
            floorAreaValue
            floorAreaUnits
            displayPrice
            displayAddress
            searchPrice
            latitude
            longitude
            description
            class
            type
            zoning
            status
          }
          images {
            url
            thumb_1024
            thumb_180
          }
        }
      }
    }
    wp {
      siteSettings {
        acf {
          propertiesBuyCta {
            title
            content
            text
            link
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 1346
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 332
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
          propertiesLeaseCta {
            title
            content
            text
            link
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 1346
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 332
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
          propertiesSoldCta {
            title
            content
            text
            link
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 1346
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 332
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
          propertiesCommercialCta {
            title
            content
            text
            link
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 1346
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 332
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
        }
      }
    }
  }
`

export default PropertyTemplate
